<div class="popup">
  <h4 mat-dialog-title>Detalles del Pedido</h4>
    <mat-card class="mat-elevation-z0">
      <table mat-table [dataSource]="Data.items" class="tabla">

      <!-- item Column -->
      <ng-container matColumnDef="articulo">
        <th mat-header-cell *matHeaderCellDef> ARTICULO </th>
        <td mat-cell *matCellDef="let element">{{element.dsName}}</td>
      </ng-container>

      <!-- cantidad Column  -->
      <ng-container matColumnDef="cantidad">
        <th mat-header-cell *matHeaderCellDef>CANTIDAD</th>
        <td mat-cell *matCellDef="let element"> {{element.nmQuantity}}</td>
      </ng-container>

       <!-- precio Column  -->
       <ng-container matColumnDef="precio">
        <th mat-header-cell *matHeaderCellDef>PRECIO </th>
        <td mat-cell *matCellDef="let element"> {{element.qtPrice}}</td>
      </ng-container>

      
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        
  </table>
  
  <br />
  <table>
    <ng-container>
      <td><h5 mat-dialog-title mat-cell>Cargo de envio: ${{Data.delivery}}</h5></td>
      <td><h5 mat-dialog-title mat-cell>Descuento: ${{Data.discount}}</h5></td>
      <td><h5 mat-dialog-title mat-cell>Sub-Total: ${{Total + Delivery - Discount}}</h5></td>
    </ng-container>
  </table>

  <br />
  <mat-dialog-content *ngIf="Data.notes" class="notas">Notas: {{Data.notes}}</mat-dialog-content>
 </mat-card> 
  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-button mat-dialog-close class="btnCerrar">Cerrar</button>
  </div>
</div>
